
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import facturacion from '../facturacion/facturacion.vue';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            facturacion
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Pedidos: Pedido[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Pedidos.Tipos.toTipo( a ), Pedidos: items[a] } );
            }
            return e;
        }

        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Ejecutando: boolean = false;
        public get Ok(): boolean
        {
            return this.Seleccionados.filter( x => x.Tags.Facturado == false ).hasRows();
        }

        public Pedidos: Pedido[] = [];
        public AbiertoFacturar: boolean = false;
        public async Ejecutar()
        {
            this.Pedidos = this.Seleccionados.filter( x => x.Tags.Facturado == false );
            console.log( this.Pedidos.length );
            if ( this.Pedidos.hasRows() )
            {
                this.$nextTick( () => this.AbiertoFacturar = !this.AbiertoFacturar );

            } else
            {
                Utiles.Notificaciones.Alerta( '¡No hay pedidos que se puedan facturar!' );
            }
        }

        async Actualizar()
        {
            this.Controlador.Buscador.Buscar();
            await this.Controlador.RecargarEstadistica();

        }
    }
